import React from 'react';
import { MedicalDataTypes, Dynamo } from '../../../../primary-record-types';
import VisitFormImpl, { VisitFormSubmitData } from './Form';
import RenderWithProviders from '../RenderWithProviders';

export type VisitFormOwnProps = {
    isLoading: boolean;
    startDateTime?: string;
    defaultResource?: MedicalDataTypes.PrimaryRecordVisit;
    defaultImages?: Dynamo.ResourceImage[];
    onSubmit: (data: VisitFormSubmitData) => void;
    isDisabled: boolean;
    profileId: string;
    resourceId?: string;
    onCancel: () => void;
    autoOpenWhenPicker?: boolean;
};

export type VisitFormProps = VisitFormOwnProps;

const VisitForm: React.FC<VisitFormProps> = (props) => {
    return (
        <RenderWithProviders
            medicalProfileId={props.profileId}
            includeSupportCareTeamMembers
            render={(providers) => <VisitFormImpl {...props} providers={providers} />}
        />
    );
};

export default React.memo(VisitForm);
